import { define } from '../redux-request';
import api from '../../api/api';

export const GET_SELECT_REP_LIST_REQUEST = define('GET_SELECT_REP_LIST_REQUEST');

export function getSelectRepListRequest(data) {
  return GET_SELECT_REP_LIST_REQUEST.request(() => api.getUserList(data));
}

export const GET_ONE_USER = define('GET_ONE_USER');

export function getOneUserRequest(data) {
  return GET_ONE_USER.request(() => api.getUserList(data));
}
